import { createFileRoute } from "@tanstack/react-router";
import IpHeadersInspectorPage from "@/pages/IpHeadersInspectorPage";

export const Route = createFileRoute("/tools/ip-inspector")({
  component: IpHeadersInspectorPage,
});
